export default __webpack_public_path__ + "static/go-goplus-5056fe61e00d9791c25f5c2f59287de8.png";